// src/ConveMain.tsx

import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import ConveSidebar from './ConveSidebar';
import { useConveChat } from './hooks/useConveChat';
import { conveAuthApi, conveTokenHelper } from './api/conveApi';
import ConveChatArea from './ConveChatArea';
import ConveFilePanel from './ConveFilePanel';
import ConveGroupChatArea from './ConveGroupChatArea';
import ConveCreateGroupModal from './ConveCreateGroupModal';
import { groupChatApi } from './api/groupChatApi';
import { useGroupWebSocket } from './hooks/useGroupWebSocket';
import { useOnlineStatus } from './hooks/useOnlineStatus';
import { GroupRoom, WsMessageType } from './types/groupChat';
import conveAxios from './api/conveApi';
import './ConveChatArea.css';
import './ConveMain.css';

const GREETINGS = [
  '오늘도 좋은 하루 되세요,',
  '반갑습니다,',
  '오늘도 화이팅이에요,',
  '좋은 생각이 넘치는 하루가 되길,',
  '오늘도 멋진 하루 보내세요,',
  '잘 오셨어요,',
  '오늘 하루도 응원해요,',
  '함께라서 든든해요,',
  '오늘도 빛나는 하루가 될 거예요,',
  '커피 한 잔 하셨나요,',
  '오늘도 최고일 거예요,',
  '좋은 일만 가득하길,',
  '오늘도 멋진 아이디어가 떠오르길,',
  '당신이 있어 더 좋은 하루예요,',
  '오늘도 즐거운 하루 되세요,',
  '무엇이든 해낼 수 있어요,',
  '오늘의 도전을 응원해요,',
  '작은 것에도 감사한 하루 되세요,',
  '오늘도 힘차게 시작해봐요,',
  '좋은 에너지 가득한 하루 되길,',
  '오늘도 당신을 응원해요,',
  '행복한 하루 보내세요,',
  '오늘도 멋지게 해낼 거예요,',
  '천천히 해도 괜찮아요,',
  '오늘 하루도 수고 많으셨어요,',
  '작은 행복들이 쌓이는 하루 되길,',
  '오늘도 건강하고 행복하세요,',
  '좋은 하루의 시작이에요,',
  '오늘도 잘 해낼 수 있어요,',
  '맑은 하늘처럼 청명한 하루 되길,',
  '오늘도 여기 있어 반가워요,',
  '따뜻한 하루 보내세요,',
  '오늘도 빠이팅이에요,',
  '당신의 하루가 특별하길,',
  '오늘도 좋은 일이 생길 거예요,',
  '즐거운 하루 시작하세요,',
  '오늘도 웃음이 가득하길,',
  '기분 좋은 하루 되세요,',
  '오늘도 든든하게 함께해요,',
  '멋진 하루가 될 거예요,',
  '오늘도 차분하고 여유롭게,',
  '좋은 생각이 떠오르는 하루 되길,',
  '오늘도 새로운 가능성이 열려요,',
  '당신의 노력이 빛날 거예요,',
  '오늘 하루도 파이팅이에요,',
  '소소한 행복이 넘치는 하루 되길,',
  '오늘도 무탈하고 평안하세요,',
  '힘내세요,',
  '오늘도 좋은 인연이 이어지길,',
  '밝고 환한 하루 되세요,',
  '오늘도 설레는 하루 되길,',
  '당신이 있어 오늘도 즐거워요,',
  '오늘도 최선을 다하는 하루 되길,',
  '행운이 함께하는 하루 되세요,',
  '오늘도 건강하게 지내세요,',
  '좋은 기운이 가득한 하루 되길,',
  '오늘도 여유 있는 하루 보내세요,',
  '당신의 하루를 응원해요,',
  '오늘도 활기차게 시작해요,',
  '좋은 소식이 들려오는 하루 되길,',
  '오늘도 포근한 하루 되세요,',
  '잘 쉬고 오셨나요,',
  '오늘도 기분 좋은 하루 만들어요,',
  '당신의 오늘이 빛나길,',
  '오늘도 즐겁게 일해요,',
  '좋은 영감이 넘치는 하루 되길,',
  '오늘도 한 발자국씩 나아가요,',
  '당신의 하루가 풍요롭길,',
  '오늘도 스마트하게 시작해요,',
  '좋은 결과가 기다리고 있어요,',
  '오늘도 집중력 넘치는 하루 되길,',
  '당신의 아이디어가 빛날 거예요,',
  '오늘도 여기서 함께해요,',
  '좋은 하루가 되길 바라요,',
  '오늘도 긍정적인 에너지 가득하길,',
  '당신의 하루가 알차길,',
  '오늘도 보람찬 하루 되세요,',
  '좋은 결정을 내리는 하루 되길,',
  '오늘도 편안하게 시작해요,',
  '당신의 열정이 빛나는 하루 되길,',
  '오늘도 스스로를 믿어요,',
  '좋은 것들이 찾아오는 하루 되길,',
  '오늘도 감사한 마음으로,',
  '당신의 오늘이 행복하길,',
  '오늘도 즐겁게 도와드릴게요,',
  '좋은 하루의 주인공은 당신이에요,',
  '오늘도 소중한 하루 보내세요,',
  '당신의 노력이 결실을 맺는 하루 되길,',
  '오늘도 여유롭고 평화로운 하루 되길,',
  '좋은 흐름을 타는 하루 되세요,',
  '오늘도 함께여서 힘이 나요,',
  '당신의 오늘에 행운을 빌어요,',
  '오늘도 반짝이는 하루 되세요,',
  '좋은 기억이 쌓이는 하루 되길,',
  '오늘도 끝까지 화이팅이에요,',
];

const MODELS = [
  'claude-haiku-4-5-20251001',
  'claude-sonnet-4-6',
  'claude-sonnet-4-5',
  'claude-opus-4-6',
];

const PANEL_MIN_WIDTH = 320;
const PANEL_MAX_WIDTH = 900;
const PANEL_DEFAULT_WIDTH = 420;

const ConveMain: React.FC = () => {
  const navigate = useNavigate();
  const { roomId } = useParams<{ roomId?: string }>();

  const {
    rooms, loadingRooms, activeRoomId,
    setActiveRoomId, loadRooms,
    createRoom, renameRoom, deleteRoom, selectRoom,
  } = useConveChat();

  const [collapsed, setCollapsed]         = useState(false);
  const [mobileOpen, setMobileOpen]       = useState(false);
  const [theme, setTheme]                 = useState<'dark' | 'light'>(() => {
    return (localStorage.getItem('conve_theme') as 'dark' | 'light') || 'light';
  });
  const [searchOpen, setSearchOpen]       = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchResults, setSearchResults] = useState(rooms);
  const [selectedModel, setSelectedModel] = useState(MODELS[0]);
  const [panelItem, setPanelItem]         = useState<any>(null);
  const [tokenUsage, setTokenUsage]       = useState<{ percent: number; used: number } | null>(null);

  // ─── 패널 리사이즈 ───────────────────────────
  const [panelWidth, setPanelWidth] = useState(PANEL_DEFAULT_WIDTH);
  const isDraggingRef  = useRef(false);
  const startXRef      = useRef(0);
  const startWidthRef  = useRef(0);

  const handleDividerMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    isDraggingRef.current = true;
    startXRef.current     = e.clientX;
    startWidthRef.current = panelWidth;
    document.body.style.cursor    = 'col-resize';
    document.body.style.userSelect = 'none';
  }, [panelWidth]);

  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (!isDraggingRef.current) return;
      // 패널은 오른쪽에 있으므로 왼쪽으로 드래그 → 넓어짐
      const delta = startXRef.current - e.clientX;
      const newWidth = Math.min(PANEL_MAX_WIDTH, Math.max(PANEL_MIN_WIDTH, startWidthRef.current + delta));
      setPanelWidth(newWidth);
    };
    const onMouseUp = () => {
      if (!isDraggingRef.current) return;
      isDraggingRef.current = false;
      document.body.style.cursor     = '';
      document.body.style.userSelect = '';
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [charCount, setCharCount] = useState(0);

  const user = conveTokenHelper.getUser();
  const canSelectModel = !!(user?.email ?? '').includes('koojaeken');
  const greeting = useMemo(() => GREETINGS[Math.floor(Math.random() * GREETINGS.length)], []);

  const isMobile = () => window.innerWidth < 1024;
  const [isMobileView, setIsMobileView] = useState(() => window.innerWidth < 1024);

  useEffect(() => {
    const handler = () => setIsMobileView(window.innerWidth < 1024);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('conve_theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  useEffect(() => {
    if (!conveTokenHelper.isLoggedIn()) {
      navigate('/conve/login');
      return;
    }
    loadRooms();
  }, []);

  useEffect(() => {
    if (roomId) {
      setActiveRoomId(Number(roomId));
      // AI 채팅방 선택 시 그룹 채팅방 닫기
      setActiveGroupRoomId(null);
    } else {
      setActiveRoomId(null);
      setTokenUsage(null);
    }
  }, [roomId]);

  useEffect(() => {
    if (!roomId) { setTokenUsage(null); return; }
    conveAxios.get(`/rooms/${roomId}/token-usage`)
      .then(res => setTokenUsage(res.data))
      .catch(() => {});
  }, [roomId]);

  useEffect(() => {
    if (!searchKeyword.trim()) {
      setSearchResults(rooms);
      return;
    }
    const lower = searchKeyword.toLowerCase();
    setSearchResults(rooms.filter(r => r.title.toLowerCase().includes(lower)));
  }, [searchKeyword, rooms]);

  const handleLogout = async () => {
    try { await conveAuthApi.logout(); } catch {}
    conveTokenHelper.clear();
    navigate('/conve/login');
  };

  const handleWithdraw = async () => {
    if (!window.confirm('정말 탈퇴하시겠습니까?')) return;
    try {
      await conveAuthApi.withdraw();
      conveTokenHelper.clear();
      navigate('/conve/login');
    } catch {
      alert('탈퇴 처리 중 오류가 발생했습니다.');
    }
  };

  const handleNewChat = async () => {
    sessionStorage.setItem('conve_focus_input', '1');
    if (isMobile()) setMobileOpen(false);
    await createRoom(selectedModel);
  };

  const handleHomeSend = async () => {
    const text = inputRef.current?.value.trim();
    if (!text) return;
    const room = await createRoom(selectedModel);
    sessionStorage.setItem('conve_pending_msg', text);
    navigate(`/conve/chat/${room.id}`);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleHomeSend();
    }
  };

  const handleInput = () => {
    const ta = inputRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 160) + 'px';
    setCharCount(ta.value.length);
  };

  const handleCodePanelOpen = useCallback((code: string, language: string) => {
    setPanelItem({ type: 'code', language, code });
  }, []);

  const handleMessageDone = useCallback(() => {
    if (!roomId) return;
    conveAxios.get(`/rooms/${roomId}/token-usage`)
      .then(res => setTokenUsage(res.data))
      .catch(() => {});
  }, [roomId]);

  const handleToggleSidebar = () => {
    if (isMobile()) setMobileOpen(p => !p);
    else setCollapsed(p => !p);
  };

  const handleSelectRoom = (id: number) => {
    if (isMobile()) setMobileOpen(false);
    // AI 채팅방 선택 시 그룹 채팅방 닫기
    setActiveGroupRoomId(null);
    selectRoom(id);
  };

  const isHome = !roomId;

  const [streamingRooms, setStreamingRooms] = useState<Set<number>>(new Set());

  const handleStreamStart = useCallback((id: number) => {
    setStreamingRooms(prev => new Set(prev).add(id));
  }, []);

  const handleStreamEnd = useCallback((id: number) => {
    setStreamingRooms(prev => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const visitedRooms = useMemo(() => {
    const ids = new Set<number>();
    if (roomId) ids.add(Number(roomId));
    streamingRooms.forEach(id => ids.add(id));
    return Array.from(ids);
  }, [roomId, streamingRooms]);

  // ─── 그룹 채팅 상태 ──────────────────────────
  const [groupRooms, setGroupRooms]               = useState<GroupRoom[]>([]);
  const [activeGroupRoomId, setActiveGroupRoomId] = useState<number | null>(null);
  const [showGroupModal, setShowGroupModal]       = useState(false);
  const [wsMessageQueue, setWsMessageQueue]        = useState<WsMessageType[]>([]);
  const { handleOnlineEvent, isOnline } = useOnlineStatus();

  const token = localStorage.getItem('conve_access_token');
  const groupRoomIds = useMemo(() => groupRooms.map((r) => r.id), [groupRooms]);

  const { sendTyping, sendRead } = useGroupWebSocket({
    roomIds: groupRoomIds,
    token,
    enabled: groupRoomIds.length > 0,
    onMessage: (msg: WsMessageType) => {
      if (msg.type === 'ONLINE') {
        handleOnlineEvent(msg.userId, msg.online);
      } else if (msg.type === 'INVITED') {
        try {
          loadGroupRooms();
        } catch (e) {
          console.error('[ConveMain] 초대 알림 처리 중 그룹방 목록 갱신 실패:', e);
          alert('초대된 채팅방 목록을 불러오는 데 실패했습니다.');
        }
      } else {
        setWsMessageQueue(prev => [...prev, msg]);
        // 안읽은 수 갱신: 현재 활성 방이 아닌 방에 메시지 왔을 때
        if (msg.type === 'MESSAGE' && msg.message.roomId !== activeGroupRoomId) {
          setGroupRooms((prev) =>
            prev.map((r) =>
              r.id === msg.message.roomId
                ? { ...r, unreadMessageCount: (r.unreadMessageCount ?? 0) + 1, lastMessage: msg.message.content }
                : r
            )
          );
        }
      }
    },
  });

  const loadGroupRooms = useCallback(async () => {
    try {
      const rooms = await groupChatApi.getMyRooms();
      setGroupRooms(rooms);
    } catch {
      // alert는 api에서 처리
    }
  }, []);

  useEffect(() => {
    if (conveTokenHelper.isLoggedIn()) {
      loadGroupRooms();
    }
  }, [loadGroupRooms]);

  const handleSelectGroupRoom = useCallback((grpRoomId: number) => {
    // 그룹 채팅방 선택 시 AI 채팅방 URL 초기화 → AI 컴포넌트 언마운트
    navigate('/conve');
    setActiveGroupRoomId(grpRoomId);
    // 읽음 표시 초기화
    setGroupRooms((prev) =>
      prev.map((r) => (r.id === grpRoomId ? { ...r, unreadMessageCount: 0 } : r))
    );
    if (isMobile()) setMobileOpen(false);
  }, [navigate]);

  const handleMessagesProcessed = useCallback((count: number) => {
    setWsMessageQueue(prev => prev.slice(count));
  }, []);

  const handleGroupTyping = useCallback(
    (roomId: number, userName: string) => {
      sendTyping(roomId, userName);
    },
    [sendTyping]
  );

  const activeGroupRoom = groupRooms.find((r) => r.id === activeGroupRoomId) ?? null;

  const isPanelOpen = !!panelItem;

  return (
    <div className="conve-main-wrap">
      {mobileOpen && (
        <div className="conve-mobile-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <ConveSidebar
        rooms={rooms}
        loadingRooms={loadingRooms}
        activeRoomId={activeRoomId}
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        tokenUsage={tokenUsage}
        selectedModel={selectedModel}
        onToggleCollapse={handleToggleSidebar}
        onNewChat={handleNewChat}
        onSelectRoom={handleSelectRoom}
        onRenameRoom={renameRoom}
        onDeleteRoom={deleteRoom}
        onSearchOpen={() => setSearchOpen(true)}
        onLogout={handleLogout}
        theme={theme}
        onToggleTheme={toggleTheme}
        onWithdraw={handleWithdraw}
        groupRooms={groupRooms}
        activeGroupRoomId={activeGroupRoomId}
        onSelectGroupRoom={handleSelectGroupRoom}
        onNewGroupChat={() => setShowGroupModal(true)}
        isOnline={isOnline}
      />

      <div className="conve-content">
        <div className="conve-mobile-header">
          <button className="conve-mobile-menu-btn" onClick={() => setMobileOpen(p => !p)}>☰</button>
          <span className="conve-mobile-title">CONV<span>E</span></span>
        </div>

        {isHome ? (
          <div className="conve-home">
            <Link to="/conve" className="conve-home-logo">CONV<span>E</span></Link>
            <div className="conve-home-greet">
              {greeting} <strong>{user?.username}</strong>님
            </div>
            <div className="conve-home-input-wrap">
              <div className="conve-input-box">
                <textarea
                  ref={inputRef}
                  className="conve-input-ta"
                  placeholder="오늘 어떤 작업을 도와드릴까요?"
                  onInput={handleInput}
                  onKeyDown={handleKeyDown}
                  rows={1}
                />
                <div className="conve-input-toolbar">
                  <div className="conve-toolbar-left">
                    <button className="conve-attach-btn" disabled title="채팅방에서 사용 가능">📎</button>
                    {canSelectModel && (
                      <select
                        className="conve-model-select"
                        value={selectedModel}
                        onChange={e => setSelectedModel(e.target.value)}
                      >
                        {MODELS.map(m => <option key={m} value={m}>{m}</option>)}
                      </select>
                    )}
                  </div>
                  <div className="conve-toolbar-right">
                    <span className={`conve-char-cnt ${charCount > 2000 ? 'warn' : ''}`}>
                      {charCount} / 2000
                    </span>
                    <button
                      className={`conve-send-btn ${charCount === 0 ? 'off' : ''}`}
                      onClick={handleHomeSend}
                      disabled={charCount === 0}
                    >↑</button>
                  </div>
                </div>
              </div>
              <div className="conve-input-hint">SHIFT+ENTER 줄바꿈 · ENTER 전송</div>
            </div>
          </div>
        ) : (
          <div style={{ display: 'contents' }}>
            {visitedRooms.map(id => (
              <div
                key={id}
                style={{
                  display: id === Number(roomId) ? 'flex' : 'none',
                  flexDirection: 'column',
                  flex: 1,
                  minHeight: 0,
                  overflow: 'hidden',
                }}
              >
                <ConveChatArea
                  roomId={id}
                  isVisible={id === Number(roomId)}
                  model={selectedModel}
                  onFilePanelOpen={(file) => setPanelItem(file)}
                  onCodePanelOpen={handleCodePanelOpen}
                  onMessageDone={handleMessageDone}
                  onStreamStart={() => handleStreamStart(id)}
                  onStreamEnd={() => handleStreamEnd(id)}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 그룹 채팅 영역 */}
      {activeGroupRoom && (
        <div
          style={{
            position: 'fixed',
            top: isMobileView ? 53 : 0,
            left: isMobileView ? 0 : (collapsed ? 60 : 260),
            right: isMobileView ? 0 : (isPanelOpen ? panelWidth : 0),
            bottom: 0,
            zIndex: isMobileView ? 50 : 10,
            background: 'var(--c-bg)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <ConveGroupChatArea
            key={`group-${activeGroupRoom.id}`}
            room={activeGroupRoom}
            currentUserId={user?.userId ?? 0}
            currentUserName={user?.username ?? ''}
            isOnline={isOnline}
            wsMessages={wsMessageQueue}
            onMessagesProcessed={handleMessagesProcessed}
            onTyping={handleGroupTyping}
            onRoomLeft={() => {
              setActiveGroupRoomId(null);
              loadGroupRooms();
            }}
          />
        </div>
      )}

      {/* 드래그 divider - 패널 열렸을 때만 */}
      {isPanelOpen && (
        <div
          className="conve-panel-divider"
          onMouseDown={handleDividerMouseDown}
          style={{ right: panelWidth }}
          title="드래그하여 크기 조절"
        />
      )}

      <ConveFilePanel
        item={panelItem}
        roomId={Number(roomId) || 0}
        onClose={() => setPanelItem(null)}
        theme={theme}
        width={isPanelOpen ? panelWidth : 0}
      />

      {showGroupModal && (
        <ConveCreateGroupModal
          currentUserId={user?.userId ?? 0}
          onClose={() => setShowGroupModal(false)}
          onCreated={(roomId) => {
            setShowGroupModal(false);
            loadGroupRooms().then(() => {
              handleSelectGroupRoom(roomId);
            });
          }}
        />
      )}

      {searchOpen && (
        <div className="conve-search-overlay" onClick={() => setSearchOpen(false)}>
          <div className="conve-search-box" onClick={e => e.stopPropagation()}>
            <div className="conve-search-input-row">
              <span className="conve-search-icon">🔍</span>
              <input
                className="conve-search-inp"
                placeholder="대화 검색..."
                autoFocus
                value={searchKeyword}
                onChange={e => setSearchKeyword(e.target.value)}
                onKeyDown={e => e.key === 'Escape' && setSearchOpen(false)}
              />
              <span className="conve-esc-badge">ESC</span>
            </div>
            <div className="conve-search-results">
              {searchResults.length === 0 ? (
                <div className="conve-search-empty">검색 결과가 없습니다</div>
              ) : (
                searchResults.map(r => (
                  <div
                    key={r.id}
                    className="conve-search-res"
                    onClick={() => {
                      selectRoom(r.id);
                      setSearchOpen(false);
                      setSearchKeyword('');
                    }}
                  >
                    <div className="conve-res-title">{r.title}</div>
                    <div className="conve-res-date">
                      {new Date(r.updatedAt).toLocaleDateString('ko-KR')}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConveMain;